import { HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject, Injector } from '@angular/core';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { AuthService as Auth0 } from '@auth0/auth0-angular';
import { AppState } from '../../store/models/app.state';
import { errorPopup } from '../../store/actions/ui.actions';
import { Router } from '@angular/router';
import { StudyManagerAuthService } from '../services/study-manager-auth/study-manager-auth.service';
import { EnvConfigService } from '../env-config/env-config.service';

export const errorHandlingInterceptorFn: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
  const store = inject<Store<AppState>>(Store);
  const router = inject(Router);
  const studyManagerAuthService = inject(StudyManagerAuthService);
  const injector = inject(Injector);

  return next(req).pipe(
    catchError(res => {
      if (res.status === 401) {
        studyManagerAuthService.clearCredentials();
        // Resolve Auth0 only after the request fails. Injecting it up front cycles through
        // AuthService -> Router -> this interceptor while AuthService is still being created.
        const auth0 = injector.get(Auth0);
        const envService = injector.get(EnvConfigService);
        auth0.loginWithRedirect({
          appState: { target: router.url },
          authorizationParams: {
            audience: envService.config().auth0.audience,
            redirect_uri: `${window.location.origin}/auth-callback`,
          },
        }).subscribe();
        return throwError(() => res);
      }

      if (res.error?.message) {
        store.dispatch(errorPopup({ error: res.error.message }));
      }
      return throwError(() => res);
    }),
  );
};
